import React from 'react'

interface Offer {
  price: number
  priceCurrency: string
  seller: string
  url: string
}

interface ProductJsonLdProps {
  name: string
  description?: string
  image?: string
  offers: Offer[]
  brand?: {
    name: string
  }
  gtin?: string
  sku?: string
}

export function ProductJsonLd({
  name,
  description,
  image,
  offers,
  brand,
  gtin,
  sku
}: ProductJsonLdProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    description,
    image,
    ...(brand && { brand: { '@type': 'Brand', name: brand.name } }),
    ...(gtin && { gtin }),
    ...(sku && { sku }),
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: offers[0]?.priceCurrency || 'EUR',
      lowPrice: Math.min(...offers.map(offer => offer.price)),
      highPrice: Math.max(...offers.map(offer => offer.price)),
      offerCount: offers.length,
      offers: offers.map(offer => ({
        '@type': 'Offer',
        price: offer.price,
        priceCurrency: offer.priceCurrency,
        seller: {
          '@type': 'Organization',
          name: offer.seller
        },
        url: offer.url
      }))
    }
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  )
}
